import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-f1607988"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30" }
const _hoisted_3 = {
  key: 0,
  class: "text-center py-5"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border text-primary",
  role: "status"
}, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-muted" }, "Chargement de la copie...", -1))
const _hoisted_6 = [
  _hoisted_4,
  _hoisted_5
]
const _hoisted_7 = { class: "d-flex align-items-center justify-content-between mb-25 p-15 rounded-2 border bg-light" }
const _hoisted_8 = { class: "fw-bold mb-0" }
const _hoisted_9 = { class: "text-muted" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "mx-2" }, "•", -1))
const _hoisted_11 = { class: "text-end" }
const _hoisted_12 = { class: "fw-bold fs-20 text-primary" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "text-muted" }, "Total actuel", -1))
const _hoisted_14 = { class: "border rounded-2 p-20" }
const _hoisted_15 = { class: "d-flex align-items-start gap-10 mb-15" }
const _hoisted_16 = {
  class: "badge bg-primary rounded-circle d-flex align-items-center justify-content-center",
  style: {"min-width":"30px","height":"30px","font-size":"14px"}
}
const _hoisted_17 = { class: "flex-grow-1" }
const _hoisted_18 = { class: "fw-medium mb-0 fs-15" }
const _hoisted_19 = { class: "text-muted" }
const _hoisted_20 = { class: "ps-40 mb-15" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, "Réponse de l'étudiant", -1))
const _hoisted_22 = { class: "p-15 rounded-2 bg-light border" }
const _hoisted_23 = {
  key: 0,
  class: "mb-0",
  style: {"white-space":"pre-wrap"}
}
const _hoisted_24 = {
  key: 1,
  class: "mb-0 text-muted fst-italic"
}
const _hoisted_25 = { class: "ps-40 row align-items-start" }
const _hoisted_26 = { class: "col-md-3" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, "Note", -1))
const _hoisted_28 = { class: "input-group" }
const _hoisted_29 = ["max", "onUpdate:modelValue"]
const _hoisted_30 = { class: "input-group-text" }
const _hoisted_31 = { class: "col-md-9" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-2" }, "Commentaire (optionnel)", -1))
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = { class: "text-center mt-30" }
const _hoisted_35 = ["disabled"]
const _hoisted_36 = { key: 0 }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm me-5" }, null, -1))
const _hoisted_38 = { key: 1 }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-check me-8" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_6))
        : (_ctx.sessionData)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, [
                  _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.sessionData.compositionTitre), 1),
                  _createElementVNode("small", _hoisted_9, [
                    _createTextVNode(" Étudiant : " + _toDisplayString(_ctx.sessionData.etudiant?.nom) + " " + _toDisplayString(_ctx.sessionData.etudiant?.prenom) + " ", 1),
                    _hoisted_10,
                    _createTextVNode(" Code session : " + _toDisplayString(_ctx.sessionData.sessionCode), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.totalNotes) + " / " + _toDisplayString(_ctx.totalBareme), 1),
                  _hoisted_13
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.questions, (q, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: q.questionId,
                  class: "mb-25"
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(index + 1), 1),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("p", _hoisted_18, _toDisplayString(q.contenu), 1),
                        _createElementVNode("small", _hoisted_19, "Barème : " + _toDisplayString(q.bareme) + " point(s)", 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_20, [
                      _hoisted_21,
                      _createElementVNode("div", _hoisted_22, [
                        (q.reponseTexte)
                          ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(q.reponseTexte), 1))
                          : (_openBlock(), _createElementBlock("p", _hoisted_24, "Aucune réponse fournie"))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _createElementVNode("div", _hoisted_28, [
                          _withDirectives(_createElementVNode("input", {
                            type: "number",
                            class: "form-control",
                            min: 0,
                            max: q.bareme,
                            step: "0.5",
                            "onUpdate:modelValue": ($event: any) => ((q.note) = $event)
                          }, null, 8, _hoisted_29), [
                            [
                              _vModelText,
                              q.note,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("span", _hoisted_30, "/ " + _toDisplayString(q.bareme), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _withDirectives(_createElementVNode("textarea", {
                          class: "form-control",
                          rows: "2",
                          placeholder: "Remarque pour l'étudiant...",
                          "onUpdate:modelValue": ($event: any) => ((q.commentaire) = $event)
                        }, null, 8, _hoisted_33), [
                          [_vModelText, q.commentaire]
                        ])
                      ])
                    ])
                  ])
                ]))
              }), 128)),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("button", {
                  class: "btn btn-success btn-lg px-40 fw-bold",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirmerCorrection && _ctx.confirmerCorrection(...args))),
                  disabled: _ctx.soumissionEnCours
                }, [
                  (_ctx.soumissionEnCours)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_36, [
                        _hoisted_37,
                        _createTextVNode(" Enregistrement... ")
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_38, [
                        _hoisted_39,
                        _createTextVNode(" Valider la correction ")
                      ]))
                ], 8, _hoisted_35)
              ])
            ], 64))
          : _createCommentVNode("", true)
    ])
  ]))
}